






















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class TeamAvatar extends Vue {
  @Prop({ type: String, required: true }) teamLogo!: string
  @Prop({ type: String, required: true }) teamName!: string
  @Prop({ type: String, default: '5rem' }) size!: string
  @Prop({ type: String, default: 'primary' }) color!: string
  @Prop({ type: Boolean, default: false }) noGutters!: boolean

  /* Methods */
  get hasValidImage() {
    return !!this.teamLogo.length
  }

  get teamNameInitial() {
    return this.teamName.substring(0, 1).toUpperCase()
  }
}
